// extracted by mini-css-extract-plugin
module.exports = {"reportTextContainer":"ReportText_reportTextContainer__bpna0","pdfMode":"ReportText_pdfMode__1YLjk"};